import Vue from 'vue'
import Vuex from 'vuex';

// Modules
import accordiFilters from "./modules/accordiFilters.module";
import auth from './modules/auth.module';
import clientiFilters from './modules/clientiFilters.module';
import contrattiDiServizioFilters from "./modules/contrattiDiServizioFilters.module";
import contrattoDiServizio from "./modules/contrattoDiServizio.module";
import fasi from './modules/fasi.module';
import praticheFilters from "./modules/praticheFilters.module";
import shared from "./modules/shared.module";
import sharedFilters from "./modules/sharedFilters.module";
import systemSnackbar from './modules/systemSnackbar.module';
import tour from './modules/tour.module';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
      accordiFilters,
      auth,
      clientiFilters,
      contrattiDiServizioFilters,
      contrattoDiServizio,
      fasi,
      praticheFilters,
      shared,
      sharedFilters,
      systemSnackbar,
      tour
    }
});